module.exports = "/* input {\r\n  width: 100%;\r\n  padding-right: 40px;\r\n} */\r\n.btn1{\r\n  width: 40px;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n}\r\n.custom-class\r\n{\r\n  border-bottom: 1px solid black;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/chains/chains.component.css
// module id = ./src/app/chains/chains.component.css
// module chunks = main